import translateJp from 'core/i18n/resources/jp';

const TRANSLATIONS_JP = {
  ...translateJp,
};

export default TRANSLATIONS_JP;
